import { render, staticRenderFns } from "./brandsinfocus-swiper.vue?vue&type=template&id=7458ce83&"
import script from "./brandsinfocus-swiper.vue?vue&type=script&lang=js&"
export * from "./brandsinfocus-swiper.vue?vue&type=script&lang=js&"
import style0 from "./brandsinfocus-swiper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports